import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from "@angular/core";
import { ItineraryService } from "../../../../../../../shared/itinerary.service";
import { RestService } from "../../../../../../../shared/rest.service";
import { UserService } from "app/pages/com.usblick.common/auth/user.service";
import { ToastrService } from "ngx-toastr";
import { getCommentadjective, getExtrasFirstRoom, starsHotels } from "./hotel-result-funtions";

@Component({
  selector: "usb-hotel-result",
  templateUrl: "./hotel-result.component.html",
  styleUrls: ["../../../base-result.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class HotelResultComponent implements OnInit {
  @Input() result: any;
  @Input() clientsSettingAppBooking: any;
  @Input() currencyAgency: any;
  @Input() payload: any;
  @Input() formData: any;
  @Input() currencies: any;
  @Input() paymentAgencyActive: any;
  @Input() arrayResults: any;
  @Input() form: any;
  @Input() index: number = 0;
  @Input() _actualItinerary: any;
  @Input() rate: number = 0;

  starArray: number[] = [1, 2, 3, 4, 5];

  @Output() openModalEmit = new EventEmitter();

  constructor(
    public serviceItinerary: ItineraryService,
    public _restService: RestService,
    public userService: UserService,
    public toastr: ToastrService,
  ) {
    }


  ngOnInit() {}

  getCommentadjective(average: any): any {
    return getCommentadjective(average);
  }

  openModal(typeModal: string): void {
    this.openModalEmit.emit(typeModal);
  }

  getAddons(extras: any[]): any[] {
    return getExtrasFirstRoom(extras);
  }

}
